// PRD 14 §4.3 / §5 — colored status pill.
//   DRAFT     → yellow (badge-warning)
//   PUBLISHED → green  (badge-success)
//   ARCHIVED  → gray   (badge-gray)

import { useTranslation } from 'react-i18next';

import type { TermVersionStatus } from '../types/terms.types';

const VARIANT_CLASS: Record<TermVersionStatus, string> = {
  DRAFT: 'badge-warning',
  PUBLISHED: 'badge-success',
  ARCHIVED: 'badge-gray',
};

interface TermStatusBadgeProps {
  status: TermVersionStatus;
}

export function TermStatusBadge({ status }: TermStatusBadgeProps) {
  const { t } = useTranslation('terms');
  return <span className={`badge ${VARIANT_CLASS[status]}`}>{t(`statuses.${status}`)}</span>;
}
